import * as React from "react";

const FilterDown = () => (
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Layer 1" viewBox="0 0 13.14 7.39">
        <title>{"filter-down"}</title>
        <path
            d="M12.32.32a.82.82 0 0 1 .58 1.4L7.15 7.47a.82.82 0 0 1-1.15 0L.24 1.72A.82.82 0 0 1 .82.32Z"
            style={{
                fill: "#002856",
            }}
            transform="translate(0 -.32)"
        />
    </svg>
);
export default FilterDown;
